import {withRouter} from 'react-router';
import moment from 'moment';
import {isNil as _isNil} from 'lodash';

import {withApollo} from 'react-apollo';
import {ArgosJobForm, setupArgosJobFormParsersAndCallbacks} from '@modules/events/forms/ArgosJob/ArgosJobForm';
import {TIME_TYPE_FIXED, TIME_TYPE_MANUAL, TIME_TYPE_MARGIN} from '@modules/events/forms/ArgosJob/ArgosJobModel';
import {convertToInt} from '@utils/helpers';

const isEmptyTimeMargin = value => _isNil(value);

class ArgosJobEditForm extends ArgosJobForm {
    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            timefieldsInitialized: false,
        };
    }
    componentDidMount() {
        setupArgosJobFormParsersAndCallbacks(this);

        if (this.props.formParams?.onSaveSuccess) {
            this.setUpdateSuccessCallback(() => {
                this.props.formParams.onSaveSuccess();
            });
        }
    }
    async componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);

        if (this?.props?.formValues?.tunnel_clients !== prevProps?.formValues?.tunnel_clients) {
            await this.fetchTunnelsForClient(this.props.formValues.tunnel_clients);
        }

        if (!this.state.timefieldsInitialized && this.props?.GraphQLEntityData?.argosJob) {
            this.timefields(this.props.GraphQLEntityData.argosJob);
            this.setState({timefieldsInitialized: true});
        }

        if (this.props?.GraphQLEntityData?.argosJob !== prevProps.GraphQLEntityData?.argosJob) {
            this.setField(['job_definition', 'region'], {
                disabled: !_isNil(this.props?.GraphQLEntityData?.argosJob?.job_uuid),
            });
        }

        if (this.props.formValues?.start_time_type !== prevProps.formValues?.start_time_type
            && this.props.formValues?.start_time_type === TIME_TYPE_MARGIN
            && isEmptyTimeMargin(this.props.formValues?.start_time_margin)
        ) {
            this.props.change('start_time_margin', '60');
        }

        if (this.props.formValues?.end_time_type !== prevProps.formValues?.end_time_type
            && this.props.formValues?.end_time_type === TIME_TYPE_MARGIN
            && isEmptyTimeMargin(this.props.formValues?.end_time_margin)
        ) {
            this.props.change('end_time_margin', '15');
        }
    }

    timefields = (entity) => {
        const {start_margin, start_datetime, end_margin, end_datetime} = entity;

        if (start_datetime && moment(start_datetime, 'YYYY-MM-DD HH:mm:ss').isSameOrBefore(moment())) {
            this.props.change('start_time_is_past', true);
            this.props.change('start_time_type', TIME_TYPE_FIXED);
            this.props.change('start_time_fixed', start_datetime);

            if (undefined !== start_margin && null !== start_margin) {
                this.props.change('start_time_margin', start_margin);
            }

            const fieldsRender = {...this.state.defaultForm_fieldsRender};

            if (fieldsRender.start_time) {
                fieldsRender.start_time.props.pastMode = true;
                fieldsRender.start_time.props.pastDateTime = moment(start_datetime, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                fieldsRender.start_time.props.pastMargin = start_margin;
                this.setState({defaultForm_fieldsRender: fieldsRender});
            }
        } else {
            this.setTimeField('start', start_margin, start_datetime);
        }

        if (end_datetime && moment(end_datetime, 'YYYY-MM-DD HH:mm:ss').isSameOrBefore(moment())) {
            this.props.change('end_time_is_past', true);
            this.props.change('end_time_type', TIME_TYPE_FIXED);
            this.props.change('end_time_fixed', end_datetime);

            if (undefined !== end_margin && null !== end_margin) {
                this.props.change('end_time_margin', end_margin);
            }

            const pastMarginText = this.props.formParams?.eventEndDatetime
                ? 'minutes after the event end time'
                : 'minutes after the end of the match';

            this.setState(prevState => {
                const fieldsRender = {...prevState.defaultForm_fieldsRender};

                if (fieldsRender.end_time) {
                    fieldsRender.end_time.props.pastMode = true;
                    fieldsRender.end_time.props.pastDateTime = moment(end_datetime, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                    fieldsRender.end_time.props.pastMargin = end_margin;
                    fieldsRender.end_time.props.pastMarginText = pastMarginText;
                }

                return {defaultForm_fieldsRender: fieldsRender};
            });
        } else {
            this.setTimeField('end', end_margin, end_datetime);
        }
    };

    setTimeField = (prefix, margin, datetime) => {
        const options = this.props.Model.fields[`${prefix}_time`].props.radioOptions;
        const fixedOpt = options.find(opt => opt.value === TIME_TYPE_FIXED);

        if (datetime) {
            this.props.change(`${prefix}_time_type`, TIME_TYPE_FIXED);

            if (fixedOpt?.name) {
                this.props.change(fixedOpt.name, datetime);
            }
        } else if (!_isNil(margin)) {
            this.props.change(`${prefix}_time_type`, TIME_TYPE_MARGIN);
            this.props.change(`${prefix}_time_margin`, margin);
        } else {
            this.props.change(`${prefix}_time_type`, TIME_TYPE_MANUAL);
        }
    };

    prepareDataForSubmit(data) {
        return {
            ...super.prepareDataForSubmit(data),
            id: convertToInt(data.id),
        };
    }
}

export default withRouter(withApollo(ArgosJobEditForm));
